var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVennreLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144.143,
    height: 39.369,
    viewBox: "0 0 144.143 39.369",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V1",
    transform: "translate(-204.9 -237.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3494",
    "data-name": "Path 3494",
    d: "M348.693,272.6l-5.387,13.433-5.32-13.433H332.5l8.778,20.882h4.09L354.18,272.6Z",
    transform: "translate(-85.172 -23.162)",
    fill: "#0a1d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3495",
    "data-name": "Path 3495",
    d: "M408.567,293.562a6.432,6.432,0,0,0-2.394-1.53,10.144,10.144,0,0,0-6.484,0,6.862,6.862,0,0,0-2.461,1.53,6.952,6.952,0,0,0-1.563,2.394,8.675,8.675,0,0,0-.565,3.192,8.392,8.392,0,0,0,.565,3.092,6.833,6.833,0,0,0,1.629,2.361,7.459,7.459,0,0,0,2.527,1.53,9.5,9.5,0,0,0,3.292.532c3.791,0,6.151-1.463,7.182-4.489h-4.489a3.015,3.015,0,0,1-2.66,1.363c-2.195,0-3.358-1.23-3.358-3.558v-.266h10.807v-.3a9.43,9.43,0,0,0-.532-3.325A7.6,7.6,0,0,0,408.567,293.562Zm-8.678,3.624.067-.3a3.047,3.047,0,0,1,1.031-1.9,3.107,3.107,0,0,1,2.095-.665,3.183,3.183,0,0,1,3.225,2.56l.066.3Z",
    transform: "translate(-126.957 -35.777)",
    fill: "#0a1d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3496",
    "data-name": "Path 3496",
    d: "M462.8,294a4.949,4.949,0,0,0-1.762-1.33,6.35,6.35,0,0,0-2.527-.466,6.086,6.086,0,0,0-2.427.432,5.469,5.469,0,0,0-2.028,1.629l-.432.532V292.5H449v14.065h4.622V299.05a3.505,3.505,0,0,1,.765-2.394,2.78,2.78,0,0,1,2.195-.865,3.484,3.484,0,0,1,1,.166,2.346,2.346,0,0,1,.865.532,2.58,2.58,0,0,1,.632,1.2,8.675,8.675,0,0,1,.166,1.8v7.082h4.622v-9.011a7.147,7.147,0,0,0-.233-2A4.186,4.186,0,0,0,462.8,294Z",
    transform: "translate(-162.934 -36.245)",
    fill: "#0a1d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3497",
    "data-name": "Path 3497",
    d: "M516.5,294a4.95,4.95,0,0,0-1.762-1.33,6.349,6.349,0,0,0-2.527-.466,6.086,6.086,0,0,0-2.427.432,5.468,5.468,0,0,0-2.028,1.629l-.432.532V292.5H502.7v14.065h4.622V299.05a3.505,3.505,0,0,1,.765-2.394,2.78,2.78,0,0,1,2.195-.865,3.484,3.484,0,0,1,1,.166,2.347,2.347,0,0,1,.865.532,2.581,2.581,0,0,1,.632,1.2,8.673,8.673,0,0,1,.166,1.8v7.082h4.622v-9.011a7.149,7.149,0,0,0-.233-2A4.186,4.186,0,0,0,516.5,294Z",
    transform: "translate(-198.779 -36.245)",
    fill: "#0a1d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3498",
    "data-name": "Path 3498",
    d: "M565.976,292.2a5.35,5.35,0,0,0-2.66.665,5.628,5.628,0,0,0-1.929,1.929l-.466.732v-2.993H556.3V306.6h4.622v-5.985a4.886,4.886,0,0,1,.964-3.259,3.519,3.519,0,0,1,2.86-1.164,5.417,5.417,0,0,1,1.962.366v-4.323c-.1,0-.2-.033-.3-.033Z",
    transform: "translate(-234.556 -36.245)",
    fill: "#0a1d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3499",
    "data-name": "Path 3499",
    d: "M605.267,293.562a6.433,6.433,0,0,0-2.394-1.53,10.144,10.144,0,0,0-6.484,0,6.863,6.863,0,0,0-2.461,1.53,6.953,6.953,0,0,0-1.563,2.394,8.676,8.676,0,0,0-.565,3.192,8.392,8.392,0,0,0,.565,3.092,6.835,6.835,0,0,0,1.629,2.361,7.458,7.458,0,0,0,2.527,1.53,9.5,9.5,0,0,0,3.292.532c3.791,0,6.151-1.463,7.182-4.489h-4.489a3.015,3.015,0,0,1-2.66,1.363c-2.195,0-3.358-1.23-3.358-3.558v-.266h10.807v-.3a9.43,9.43,0,0,0-.532-3.325A6.634,6.634,0,0,0,605.267,293.562Zm-8.679,3.624.067-.3a3.046,3.046,0,0,1,1.031-1.9,3.107,3.107,0,0,1,2.095-.665,3.183,3.183,0,0,1,3.225,2.56l.066.3Z",
    transform: "translate(-258.252 -35.777)",
    fill: "#0a1d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11072",
    "data-name": "Group 11072",
    transform: "translate(204.9 237.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3500",
    "data-name": "Path 3500",
    d: "M271.9,298.64l4.655-2.66V276.794L271.9,274.2Z",
    transform: "translate(-249.622 -262.13)",
    fill: "#0a1d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3501",
    "data-name": "Path 3501",
    d: "M254.255,276.039V239l-2.361-1.1L249.6,239v37.042l2.294,1.23Z",
    transform: "translate(-234.737 -237.9)",
    fill: "#0a1d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3502",
    "data-name": "Path 3502",
    d: "M294.2,302.827l4.688-2.693v-10.64L294.2,286.8Z",
    transform: "translate(-264.507 -270.54)",
    fill: "#0a1d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3503",
    "data-name": "Path 3503",
    d: "M204.9,281.444l4.688,2.693V258.8l-4.688,2.793Z",
    transform: "translate(-204.9 -251.85)",
    fill: "#0a1d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3504",
    "data-name": "Path 3504",
    d: "M227.3,277.29l4.655,2.66V246.2l-4.655,2.627Z",
    transform: "translate(-219.852 -243.44)",
    fill: "#0a1d56"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVennreLogo);
export default __webpack_public_path__ + "static/media/vennre_logo.d007f5f116ceb8c753f6f8ede9d0f6d9.svg";
export { ForwardRef as ReactComponent };